import { useReduxState } from "../../explorer/redux/hooks";
import { reduxStoreConfig } from "../configuration/reduxStoreConfig";

export const useApiNotification: () => [string | undefined, (error: string | undefined) => void] = () => {
  const [notification, setNotification] = useReduxState<string | undefined>(reduxStoreConfig.systemApiNotification);
  return [notification, setNotification];
};
